import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { DesktopFooter } from '@vc-workspace/desktop-footer';
import { MobileFooter } from '@vc-workspace/mobile-footer';
import Head from 'next/head';
import AboutUsContent from '../components/about-us-content/about-us-content';
import GlobalContextWrapper from '../components/global-context-wrapper/global-context-wrapper';
export var __N_SSP = true;
export function About(_ref) {
  var context = _ref.context;
  return /*#__PURE__*/_jsxs(GlobalContextWrapper, {
    context: context,
    hideCategoriesList: true,
    children: [/*#__PURE__*/_jsx(Head, {
      children: /*#__PURE__*/_jsx("title", {
        children: "About Vibecity"
      })
    }), /*#__PURE__*/_jsx(AboutUsContent, {
      context: context
    }), context.isMobileView ? /*#__PURE__*/_jsx(MobileFooter, {}) : /*#__PURE__*/_jsx(DesktopFooter, {})]
  });
}
export default About;